export { DecorationMode as DECORATION_MODE } from 'wix-rich-content-common';

const ACTION_COLOR = "var(--ricos-settings-action-color, var(--ricos-action-color-fallback, #0261ff))";
const BG_COLOR = "var(--ricos-settings-bg-color-background-color, rgba(0,0,0,.2))";
const ACTION_COLOR_LIVESITE = "var(--ricos-native-text-color,  var(--ricos-action-color, #0261ff))";
const BG_COLOR_LIVESITE = "var(--ricos-native-secondary-bg-color-background-color, rgba(var(--ricos-text-color-low-tuple, 150, 150, 150),.2) )";
const FOOTER_BUTTON_ALIGNMENT = Object.freeze({
  CENTER: "center",
  END: "end"
});
const SLIDER_THUMB_VISIBILITY = { hover: "hover", fixed: "fixed" };
const SLIDER_TRACK_SIZE = { small: "small_track", medium: "medium_track" };
const MODAL_CONTROLS_POSITION = Object.freeze({
  TOP: "top",
  BOTTOM: "bottom"
});
const KEYS_CHARCODE = {
  ENTER: 13,
  ESCAPE: 27,
  SPACE: 32
};
const BUTTON_SIZE = {
  tiny: "tiny",
  small: "small",
  medium: "medium",
  large: "large"
};
const DesktopFlyOutModalContentStyles = {
  boxSizing: "border-box",
  height: "fit-content",
  minHeight: 165,
  width: "fit-content",
  minWidth: 365,
  maxHeight: "100%",
  maxWidth: 444,
  overflow: "visible",
  border: "solid 1px rgba(51, 51, 51, 0.1)",
  display: "block",
  borderRadius: "var(--ricos-settings-whitebox-border-radius, 2px)",
  position: "absolute",
  zIndex: 6,
  padding: 20,
  boxShadow: "var(--ricos-settings-whitebox-box-shadow, 0 0 10px 0 rgba(0, 0, 0, 0.06))"
};
const DesktopFlyOutModalStyles = Object.freeze({
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0)",
    zIndex: 5
  },
  content: DesktopFlyOutModalContentStyles
});
const MobileFullscreenCustomContentStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  overflow: "hidden",
  width: "100vw",
  boxSizing: "border-box"
};
const MOBILE_FULL_SCREEN_CUSTOM_STYLE = Object.freeze({
  overlay: {
    backgroundColor: "transparent"
  },
  content: MobileFullscreenCustomContentStyle
});
const DesktopOverlayModalStyles = Object.freeze({
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.4)"
  }
});

export { ACTION_COLOR, ACTION_COLOR_LIVESITE, BG_COLOR, BG_COLOR_LIVESITE, BUTTON_SIZE, DesktopFlyOutModalStyles, DesktopOverlayModalStyles, FOOTER_BUTTON_ALIGNMENT, KEYS_CHARCODE, MOBILE_FULL_SCREEN_CUSTOM_STYLE, MODAL_CONTROLS_POSITION, SLIDER_THUMB_VISIBILITY, SLIDER_TRACK_SIZE };
//# sourceMappingURL=consts.js.map
